import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.tsx';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds.ts';
import { Button, Flex, Text } from '@mantine/core';
import ReactModal from 'react-modal';
import type { SecurityWarningModalProps } from './SecurityWarningModal.types';

export const SecurityWarningModal = ({
	description,
	onRevert,
	onClose,
	onConfirm,
}: SecurityWarningModalProps) => {
	const tCapManage = useTranslationCapManage();

	const warningColor = defaultTheme.v2.color.warning[600];

	return (
		<ReactModal
			contentLabel="security-warning-modal"
			isOpen
			className="ReactModal__Content"
			style={{
				content: {
					background: defaultTheme.v2.color.neutral[100],
					borderRadius: '0.5rem',
					padding: '1rem 1.25rem',
					minWidth: '34rem',
					maxWidth: '38rem',
					display: 'flex',
					gap: '1rem',
					boxShadow: `0 0.125rem 0.25rem 0 ${defaultTheme.v2.color.neutral[500]}`,
				},
			}}
		>
			<div
				style={{
					width: '0.25rem',
					minWidth: '0.25rem',
					borderRadius: '0.5rem',
					background: warningColor,
				}}
			/>
			<Flex direction="column" gap="1rem" style={{ flex: 1 }}>
				<Flex align="center" gap="0.5rem">
					<Icon variant="exclamation-circle" size="xl" color={warningColor} />
					<Text fw={700}>{tCapManage('security_tracking_warning_modal.title')}</Text>
				</Flex>
				<Text>{description}</Text>
				<Flex gap="xs">
					{onRevert ? (
						<>
							<Button
								size="md"
								variant="secondary"
								data-testid={
									TEST_ELEMENT_IDS.CAP_SECURITY_WARNING_MODAL_REVERT_BUTTON
								}
								onClick={() => {
									onRevert();
									onClose();
								}}
							>
								{tCapManage('security_tracking_warning_modal.back')}
							</Button>
							<Button
								size="md"
								variant="subtle"
								data-testid={
									TEST_ELEMENT_IDS.CAP_SECURITY_WARNING_MODAL_CONFIRM_BUTTON
								}
								onClick={onConfirm ?? onClose}
							>
								{tCapManage('security_tracking_warning_modal.confirm')}
							</Button>
						</>
					) : (
						<Button
							size="md"
							variant="subtle"
							data-testid={TEST_ELEMENT_IDS.CAP_SECURITY_WARNING_MODAL_CLOSE_BUTTON}
							onClick={onClose}
						>
							{tCapManage('security_tracking_warning_modal.close', {
								defaultValue: 'Close',
							})}
						</Button>
					)}
				</Flex>
			</Flex>
		</ReactModal>
	);
};
